import { render, staticRenderFns } from "./invadobay.vue?vue&type=template&id=85cf865a&scoped=true"
import script from "./invadobay.vue?vue&type=script&lang=js"
export * from "./invadobay.vue?vue&type=script&lang=js"
import style0 from "./invadobay.vue?vue&type=style&index=0&id=85cf865a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf865a",
  null
  
)

export default component.exports